export const CopyNo = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 29H15C13.8954 29 13 28.1046 13 27V15C13 13.8954 13.8954 13 15 13H27C28.1046 13 29 13.8954 29 15V16" stroke="currentColor" stroke-width="2"/>
<path d="M10 20H5C3.89543 20 3 19.1046 3 18V5C3 3.89543 3.89543 3 5 3H18C19.1046 3 20 3.89543 20 5V10" stroke="currentColor" stroke-width="2"/>
<circle cx="25" cy="25" r="6" stroke="currentColor" stroke-width="2"/>
<path d="M27.4244 22.5709L22.5756 27.4197" stroke="currentColor" stroke-width="2"/>
<path d="M27.4244 27.4197L22.5756 22.5709" stroke="currentColor" stroke-width="2"/>
</svg>`;
